import { FC } from 'react';
import { ModalComponent } from '.';
import { DuplicateType, LookupRecipient } from 'store/recipients/types';

interface Props {
  isOpen: boolean;
  duplicates: LookupRecipient[];
  duplicateType: DuplicateType;
  onCancel: () => void;
  onContinueAnyway?: () => void;
  onViewExisting: (recipientId: string) => void;
}

export const DuplicateWarningModal: FC<Props> = ({
  isOpen,
  duplicates,
  duplicateType,
  onCancel,
  onContinueAnyway,
  onViewExisting,
}) => {
  const isEinDuplicate = duplicateType === 'ein';

  return (
    <ModalComponent
      isOpen={isOpen}
      closeModal={onCancel}
      contentClassName="duplicate-warning-modal"
    >
      <span className="oath-eyebrow inkBlue">Duplicate recipient found</span>

      <span className="oath-body inkBlue duplicate-warning-modal__subtitle">
        {isEinDuplicate
          ? 'A recipient with this EIN already exists. EINs must be unique and cannot be bypassed.'
          : 'One or more recipients with a similar name already exist. You can continue anyway or view the existing recipient.'}
      </span>

      <ul className="duplicate-warning-modal__list">
        {duplicates.map(recipient => (
          <li key={recipient.recipient_id} className="duplicate-warning-modal__list-item">
            <div className="duplicate-warning-modal__list-item-info">
              <span className="oath-bodysmall inkBlue duplicate-warning-modal__list-item-name">
                {recipient.display_name}
              </span>
              <span className="oath-bodysmall gray">
                {recipient.legal_id ? `EIN: ${recipient.legal_id}` : 'No EIN'} ·{' '}
                {recipient.subtype ?? '—'}
              </span>
            </div>
            <button
              type="button"
              className="oath-bodysmall link-text inkBlue padding0 duplicate-warning-modal__view-btn"
              onClick={() => onViewExisting(recipient.recipient_id)}
            >
              View
            </button>
          </li>
        ))}
      </ul>

      <div className="duplicate-warning-modal__actions">
        {!isEinDuplicate && onContinueAnyway && (
          <button
            type="button"
            className="btn-inkBlue btn btn-secondary"
            onClick={onContinueAnyway}
          >
            Continue anyway
          </button>
        )}
        <button
          type="button"
          className="oath-bodysmall link-text inkBlue padding0"
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </ModalComponent>
  );
};
